export { default as name } from './name.js';
export { default as domain } from './domain.js';
export { default as nonNumeric } from './nonNumeric.js';
export { default as wildcardDomain } from './wildcardDomain.js';
export { default as ipv4 } from './ipv4.js';
export { default as ipv4Cidr } from './ipv4Cidr.js';


// WEBPACK FOOTER //
// ./src/common/reg/index.js